export const isRunningInDesktop = !!window.Bridge

export const oldDesktopVersion = !window.Bridge?.getVersion && !window.Bridge?.version
export const desktopVersion = window.Bridge?.version
export const getDesktopVersion = async () => {
  // This is here for legacy sake, newest version of app has getVersion
  if (window.Bridge?.version) {
    return window.Bridge?.version
  } else if (window.Bridge?.getVersion) {
    return window.Bridge.getVersion()
  }
  return undefined
}
export const isRunningInBrowser = !isRunningInDesktop
